<template>

  <v-container fluid grid-list-md>
      <v-flex xs12>
        <v-avatar v-show="previewImage && !disablePreview && avatar"
            :size="avatarSize"
            class="grey lighten-4">
          <img :src="previewImage" alt="avatar">
        </v-avatar>

        <img :width="imageSize" v-show="previewImage && !disablePreview && !avatar"
          :src="previewImage" :class="imageClass" />
      </v-flex>

      <v-flex xs12>
        <div :style="wrapperStyles">
          <v-btn color="primary" dark class="mb-2" @click.native="openBrowserAddFile">
            <span> Alterar Imagem </span>
          </v-btn>
          <input ref="file" style="display: none;" type="file" @change="onChange"
            :style="fileInputStyles" :accept="accept" />
        </div>
      </v-flex>
  </v-container>

</template>

<script>

  export default {

    props: {
      imageClass: {
        type: String,
        default: '',
      },
      accept: {
        type: String,
        default: 'image/png,image/gif,image/jpeg',
      },
      maxSize: {
        type: Number,
        default: 10,
      },
      disablePreview: {
        type: Boolean,
        default: false,
      },
      avatar: {
        type: Boolean,
        default: false,
      },
      avatarSize: {
        type: String,
        default: '100px',
      },
      imageSize: {
        type: Number,
        default: 200,
      },
      defaultPreview: {
        type: String,
        default: '',
      },
    },

    data: function data() {
      return {
        file: null,
        preview: null,
        visiblePreview: false,
      };
    },
    computed: {
      wrapperStyles() {
        return {
          position: 'relative',
          width: '100%',
        };
      },
      fileInputStyles() {
        return {
        };
      },
      textInputStyles() {
        return {
        };
      },
      previewImage() {
        return this.preview || this.defaultPreview;
      },
    },

    methods: {
      onChange(e) {
        const files = e.target.files || e.dataTransfer.files;

        if (!files.length) {
          return;
        }

        const file = files[0];
        const size = file.size && file.size / (1000 ** 2);

        // check file max size
        if (size > this.maxSize) {
          this.$emit('size-exceeded', size);
          return;
        }

        // update file
        this.file = file;
        this.$emit('file', file);

        const reader = new FileReader();

        reader.onload = (val) => {
          const dataURI = val.target.result;

          if (dataURI) {
            this.$emit('load', dataURI);
            this.preview = dataURI;
          }
        };

        // read blob url from file data
        reader.readAsDataURL(file);
      },
      openBrowserAddFile() {
        this.$refs.file.click();
      },
    },
  };
</script>

<style scoped>

.btn-file {
  padding: 0 16px;
}

</style>



// WEBPACK FOOTER //
// src/components/widgets/PrUploadFile.vue